export default "__VITE_ASSET__CfH2AuwB__"